<template>
    <div>
    </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载
export default {
    data() {
        return{
            path:""
        }
    },
    created() {
        this.path=this.$getUrlKey("path");
        let that=this;
        dd.ready(function () {
            dd.runtime.permission.requestAuthCode({
                corpId: "dingcb67ff33be150f4c", // 企业id
                onSuccess: function (info) {
                    //let code = info.code // 通过该免登授权码可以获取用户身份
                    that.getDDUserInfo(info.code);
                    //console.log(this.code);
                },
                onFail: function (err) {
                    alert(err.errorMessage);
                }
            });
        });
    },
    methods: {
        getDDUserInfo(code) {
            this.$post("/ddstaff/getDDUserInfo", {requestAuthCode: code}).then((res) => {
                let data = res.object;
                if (res.sucess) {
                    if (data.ddstaff == null || data.ddstaff == undefined) {
                        //如果钉钉没找到就关闭页面
                        dd.biz.navigation.close({
                            onSuccess: function (result) {},
                            onFail: function (err) {}
                        });
                        return;
                    }
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("ddstaffid", data.ddstaff.userid);
                    localStorage.setItem("staffid", data.staff.staffid);
                    localStorage.setItem("storeid", data.staff.storeid);
                    localStorage.setItem("deptid", data.staff.deptid);
                    localStorage.setItem("staffname", data.staff.staffname);
                    localStorage.setItem("posid", data.staff.posid);
                    this.$router.push({
                        path: this.path
                    });
                } else {
                    this.$dialog.alert({
                        title: "提示",
                        message: res.message
                    });
                }
            });

        }
    }
}

</script>


// WEBPACK FOOTER //
// src/page/login/ddlogin.vue